package com.eladfinish.bible.contest.screens.americanQuestions

import com.eladfinish.bible.contest.constants.Constants
import com.eladfinish.bible.contest.network.ApiResult
import com.eladfinish.bible.contest.network.spreadsheet.SpreadsheetApi
import com.eladfinish.bible.contest.network.spreadsheet.toSpreadsheetMatrixTest
import com.eladfinish.bible.contest.screens.americanQuestions.model.AmericanQuestionSheetEntry
import com.eladfinish.bible.contest.screens.americanQuestions.model.toAmericanQuestionEntries
import com.eladfinish.bible.contest.utils.spreadsheet.getId

interface AmericanQuestionsRepository {
    /** Fetches raw question entries from the spreadsheet. */
    suspend fun fetchEntries(): Result<List<AmericanQuestionSheetEntry>>
}

class AmericanQuestionsRepositoryImpl(
    private val spreadsheetApi: SpreadsheetApi,
) : AmericanQuestionsRepository {

    override suspend fun fetchEntries(): Result<List<AmericanQuestionSheetEntry>> {
        return when (
            val result = spreadsheetApi.getDataFromSpreadsheet(
                spreadsheetId = Constants.google_spreadsheet_american_questions.getId()
            )
        ) {
            is ApiResult.Failure -> Result.failure(result.cause)
            is ApiResult.ClientError -> Result.failure(result.throwable)
            is ApiResult.Success -> runCatching {
                result.data
                    .toSpreadsheetMatrixTest()
                    .toAmericanQuestionEntries()
            }
        }
    }
}
